import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { TenantView } from "./TenantView";
import { TenantViewStore } from "../../store/TenantViewStore";
import { useStore } from "../../../../hooks";

export const TenantViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/tenant/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new TenantViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            { id: "tenant", label: rootStore.langStore.groupTenantTenantLabel },
            {
              id: "llmLimits",
              label: rootStore.langStore.groupTenantLlmLimitsLabel,
            },
            {
              id: "storageLimits",
              label: rootStore.langStore.groupTenantStorageLimitsLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <TenantView tenantViewStore={store} />
      </PageLayout>
    </div>
  );
});
